// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2N-Ev","actionsCol":"EnrolledClinics_actionsCol__297ey"};